<div class="transport-action-bar toolbar">
  <div class="group group-transport">
    <div class="buttons">
      <sc-action-icon (click)="register()" iconClass="fa-plus"
      [matTooltip]="'Register' | translate: ['tmc.visit.overview.action.register', translationService.language, translationService.revision]"></sc-action-icon>

      <sc-action-icon mat-icon-button (click)="registerTransportForVehicle()"
        [disabled]="registerTransportForVehicleDisabled"
        [matTooltip]="'Register' | translate: ['tmc.visit.overview.action.register-for-vehicle', translationService.language, translationService.revision]"
        iconClass="fa-square-plus">
      </sc-action-icon>

      <sc-action-icon iconClass="fa-route" (click)="editRoute()" [disabled]="editRouteDisabled"
      [matTooltip]="'Edit Route' | translate: ['tmc.visit.overview.action.editRoute', translationService.language, translationService.revision]"></sc-action-icon>
      <sc-action-icon (click)="editTransport()" [disabled]="editTransportDisabled"
        [matTooltip]="'edit transport' | translate: ['tmc.visit.overview.action.editTransport', translationService.language, translationService.revision]"
        iconClass="fa-edit">
      </sc-action-icon>
      <sc-action-icon (click)="showTransportDetails()" [disabled]="showTransportDetailsDisabled"
        [matTooltip]="'Transport Details' | translate: ['tmc.visit.overview.action.showTransportDetails', translationService.language, translationService.revision]"
        iconClass="fa-info">
      </sc-action-icon>
      <sc-action-icon (click)="deleteTransport()" [disabled]="deleteTransportDisabled"
        [matTooltip]="'delete transport' | translate: ['tmc.visit.overview.action.cancelTransport', translationService.language, translationService.revision]"
        iconClass="fa-times">
      </sc-action-icon>
      @if (cps.isPropertyTrue('feature.globalconnect', true)) {
        <sc-action-icon (click)="showGcCase()" [disabled]="showGcCaseDisabled"
          [matTooltip]="'QC-Case' | translate: ['tmc.visit.overview.action.showGcCase', translationService.language, translationService.revision]"
          iconClass="fa-mobile-android-alt">
        </sc-action-icon>
      }
      <sc-action-icon mat-icon-button [matMenuTriggerFor]="menu" [disabled]="editTransportDisabled"
        [matTooltip]="'print Handout' | translate: ['tmc.visit.overview.action.printHandout', translationService.language, translationService.revision]"
        iconClass="fa-print">
      </sc-action-icon>
      <mat-menu #menu="matMenu">
        <sc-padding (click)="printTransportSheet()" class="pointer">
          <sc-flex>
            <sc-icon iconClass="fa-truck"></sc-icon>
            <sc-content-spacer></sc-content-spacer>
            <sc-dictionary-label dictionaryKey="tmc.visit.overview.action.printAccessHandout"></sc-dictionary-label>
          </sc-flex>
        </sc-padding>
        <sc-padding (click)="printCommunicationSheet()" class="pointer">
          <sc-flex>
            <sc-icon iconClass="fa-qrcode"></sc-icon>
            <sc-content-spacer></sc-content-spacer>
            <sc-dictionary-label
            dictionaryKey="tmc.visit.overview.action.printCommunicationHandout"></sc-dictionary-label>
          </sc-flex>
        </sc-padding>
      </mat-menu>
    </div>
    <div class="title">
      <sc-dictionary-label dictionaryKey="tmc.visit.overview.action-group.transport"></sc-dictionary-label>
    </div>
  </div>
  <div class="group group-transport">

    <div class="buttons">

      <sc-action-icon iconClass="fa-truck fa-flip-horizontal" secondaryIconClass="fa-industry"
        (click)="registerEntranceNew()"
      [matTooltip]="'edit issues' | translate: ['tmc.visit.overview.action.registerEntrance', translationService.language, translationService.revision]"></sc-action-icon>

      <sc-action-icon iconClass="fa-truck" secondaryIconClass="fa-industry" (click)="registerLeaveNew()"
        [disabled]="registerLeaveDisabled"
      [matTooltip]="'Register Leave' | translate: ['tmc.visit.overview.action.registerLeave', translationService.language, translationService.revision]"></sc-action-icon>

      @if (cps.isPropertyTrue('clientproperty.visitors.feature_enablement.pause', false)) {
        <sc-action-icon (click)="pauseTransport()" [disabled]="pauseTransportDisabled"
          [matTooltip]="'pause transport' | translate: ['tmc.visit.overview.action.pauseTransport', translationService.language, translationService.revision]"
          iconClass="fa-stopwatch">
        </sc-action-icon>
      }
      @if (cps.isPropertyTrue(clientParameters.P_VISITS_ATTACH_DETACH_ENABLED, false)) {
        <sc-action-icon (click)="attachDetachTransport()" [disabled]="attachDetachTransportDisabled"
          [matTooltip]="'split / merge' | translate: ['tmc.visit.overview.action.attachDetach', translationService.language, translationService.revision]"
          iconClass="fa-code-merge">
        </sc-action-icon>
      }
      @if (cps.isPropertyTrue('features.link-transports', false)) {
        <app-link-transport-dialog-action [transportId]="transport?.id" [disabled]="linkTransportsDisabled"
          (onChange)=" handleChange()">
        </app-link-transport-dialog-action>
      }
      @if (cps.isPropertyTrue(clientParameters.FEATURES_UMBRUECKUNG, false)) {
        <sc-action-icon (click)="performTransportUmbrueckung()" [disabled]="umbrueckungDisabled"
          [matTooltip]="'swap trailer' | translate: ['tmc.visit.overview.action.transportUmbrueckung', translationService.language, translationService.revision]"
          iconClass="fa-random">
        </sc-action-icon>
      }
      <sc-action-icon (click)="sendMessage()" [disabled]="sendMessageDisabled"
        [matTooltip]="'send message' | translate: ['tmc.visit.overview.action.sendMessage', translationService.language, translationService.revision]"
        iconClass="fa-envelope">
      </sc-action-icon>
    </div>
    <div class="title">
      <sc-dictionary-label dictionaryKey="tmc.visit.overview.action-group.control"></sc-dictionary-label>
    </div>
  </div>
  <div class="group group-transport">
    <div class="buttons">
      <sc-action-icon (click)="handoutSupplementaryEquipment()" [disabled]="handoutSupplementaryEquipmentDisabled"
        [matTooltip]="'Handout Supplementary Equipment' | translate: ['tmc.visit.overview.action.handoutSupplementaryEquipment', translationService.language, translationService.revision]"
        iconClass="fa-upload">
      </sc-action-icon>
      <sc-action-icon (click)="takeBackSupplementaryEquipment()" [disabled]="takeBackSupplementaryEquipmentDisabled"
        [matTooltip]="'Take back Supplementary Equipment' | translate: ['tmc.visit.overview.action.takeBackSupplementaryEquipment', translationService.language, translationService.revision]"
        iconClass="fa-download">
      </sc-action-icon>
      @if (cps.isPropertyTrue(this.clientParameters.FEATURES_ISSUES, false)) {
        <sc-action-icon (click)="editIssues()" [disabled]="editIssuesDisabled"
          [matTooltip]="'edit issues' | translate: ['tmc-yard.ui.transport-issues-dialog.action.addIssue', translationService.language, translationService.revision]"
          iconClass="fa-exclamation-triangle">
        </sc-action-icon>
      }
      @if (yardPropertiesService.isWeighingEnabled()) {
        <sc-action-icon (click)="weighTransport()" [disabled]="weighTransportDisabled"
          [matTooltip]="'Weigh Transport' | translate: ['tmc.visit.overview.action.weighTransport', translationService.language, translationService.revision]"
          iconClass="fa-balance-scale">
        </sc-action-icon>
      }
    </div>
    <div class="title">
      <sc-dictionary-label dictionaryKey="tmc.visit.overview.action-group.documentation"></sc-dictionary-label>
    </div>
  </div>
  <div class="group group-ungrouped">
    <div class="buttons">
      <sc-action-icon mat-icon-button (click)="emergencyCall()" [disabled]="emergencyCallDisabled"
        [matTooltip]="'emergency call' | translate: ['tmc.visit.overview.action.emergencyCall', translationService.language, translationService.revision]"
        iconClass="fa-siren-on">
      </sc-action-icon>
      @if (!simulatorStarted && simulatorEnabled) {
        <sc-action-icon mat-icon-button (click)="toggleSimulation()"
          [matTooltip]="'Start Simulator' | translate: ['tmc.visit.overview.action.simulator.start', translationService.language, translationService.revision]"
          iconClass="fa-play">
        </sc-action-icon>
      }
      @if (simulatorStarted && simulatorEnabled) {
        <sc-action-icon mat-icon-button (click)="toggleSimulation()"
          [matTooltip]="'Stop Simulator' | translate: ['tmc.visit.overview.action.simulator.stop', translationService.language, translationService.revision]"
          iconClass="fa-stop">
        </sc-action-icon>
      }
      @if (cleanTransportFeatureAvailable) {
        <sc-action-icon mat-icon-button (click)="cleanTransport()"
          [disabled]="cleanTransportDisabled"
          [matTooltip]="'Cleanup Transport' | translate: ['tmc.visit.overview.action.clean-transport', translationService.language, translationService.revision]"
          iconClass="fa-broom">
        </sc-action-icon>
      }
      <sc-action-icon mat-icon-button (click)="activateTransports()"
        [matTooltip]="'activate' | translate: ['tmc.visit.overview.action.activate', translationService.language, translationService.revision]"
        iconClass="fa-search-plus">
      </sc-action-icon>
    </div>
    <div class="title">
      <sc-dictionary-label dictionaryKey="tmc.visit.overview.action-group.others"></sc-dictionary-label>
    </div>
  </div>
</div>
